var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-clamp',_vm._b({attrs:{"autoresize":""},scopedSlots:_vm._u([{key:"after",fn:function({ toggle, clamped, expanded }){return [(clamped === true || expanded === true)?_c('button',{staticClass:"mx-3",on:{"click":$e => {
          $e.preventDefault();
          toggle();
        }}},[_vm._v(" "+_vm._s(clamped === true ? 'Show more' : 'Show less')+" ")]):_vm._e()]}}])},'v-clamp',[_vm.$props, _vm.$attrs],false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }